import classnames from 'classnames';
import videojs from 'video.js';

import { Event } from '@src/types/event';

export const FullscreenToggle = videojs.getComponent('FullscreenToggle');

class FloatingCloseButton extends FullscreenToggle {
  buildCSSClass() {
    return classnames(
      super.buildCSSClass(),
      'vjs-floating-close-button',
      'vjs-control-floating-button'
    );
  }

  handleClick(event: videojs.EventTarget.Event) {
    if (this.player_.isFullscreen()) {
      super.handleClick(event);
    }

    this.player_.trigger(Event.X_CLICK_CLOSEBTN);
  }
}

videojs.registerComponent('FloatingCloseButton', FloatingCloseButton);

export default FloatingCloseButton;
